_onload_functions[_onload_functions.length] = function() {
  jQuery(".show-tooltip").qtip({
    "style": {
      "classes": "qtip-bootstrap"
    },
    "hide": {
      "fixed": true,
      "delay": 500
    }
  });
};